import React from "react";

import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";

import CustomAutoCompleteFilter from "../../lib/components/customdatagridfilter/CustomFilter";

import { format } from "date-fns";
import parseISO from "date-fns/parseISO";
import { CellActionsFormatter } from "../../lib/helpers/CellActionsFormatter";

const cellWidthSmall = 80;
const cellWidthSmallBig = 120;
const cellWidthMedium = 200;
const cellWidthBig = 250;

const defaultColumnProperties = {
  resizable: true,
  sortable: true,
};

const formatterValidfrom = ({ row, column }) => {
  const data = row[column.key];
  if (data) {
    const filterDate = format(parseISO(data), "dd MMM yyyy");
    return <div>{filterDate}</div>;
  }
  return <div></div>;
};

const formatterValidto = ({ row, column }) => {
  const data = row[column.key];
  if (data) {
    const filterDate = format(parseISO(data), "dd MMM yyyy");
    return <div>{filterDate}</div>;
  }
  return <div></div>;
};

let currentSpace = true;
export const GridColumns = (data, filters, handleRemove, handleEdit) => {
  let postValue = "";

  if (data) {
    if (currentSpace) {
      postValue = " ";
    }
    currentSpace = !currentSpace;
  }

  return [
    {
      key: "actions",
      name: "Actions",
      width: cellWidthSmall,
      formatter: ({ row }) => {
        const actions = cellActions(row, handleRemove, handleEdit);
        return (
          <div style={{ display: "flex", justifyContent: "center", gap: "5px" }}>
            <CellActionsFormatter actions={actions} />
          </div>
        );
      },
    },
    {
      key: "validfrom",
      name: "Valid From" + postValue,
      width: cellWidthSmallBig,
      filterable: true,
      formatter: formatterValidfrom,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"validfrom"} data={data} section={"producerphgridsetup"} />;
      },
    },
    {
      key: "validto",
      name: "Valid To" + postValue,
      width: cellWidthSmallBig,
      filterable: true,
      formatter: formatterValidto,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"validto"} data={data} section={"producerphgridsetup"} />;
      },
    },
    {
      key: "producerphtype_detail",
      name: "PH Type" + postValue,
      width: cellWidthMedium,
      filterable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"producerphtype_detail"} data={data} section={"producerphgridsetup"} />;
      },
    },
  ].map((c) => ({ ...c, ...defaultColumnProperties }));
};

const cellActions = (row, handleRemove, handleEdit) => {
  return [
    {
      icon: (
        <span title="Edit">
          <EditIcon style={{ cursor: "pointer", color: "orange" }} />
        </span>
      ),
      callback: (e) => {
        handleEdit(row.id);
      },
    },
    {
      icon: (
        <span title="Remove">
          <DeleteIcon style={{ cursor: "pointer", color: "red" }} />
        </span>
      ),
      callback: (e) => {
        handleRemove(row.id);
      },
    },
  ];
};
